import { render, staticRenderFns } from "./commonDialog2.vue?vue&type=template&id=2e4a6d7d&scoped=true"
import script from "./commonDialog2.vue?vue&type=script&lang=js"
export * from "./commonDialog2.vue?vue&type=script&lang=js"
import style0 from "./commonDialog2.vue?vue&type=style&index=0&id=2e4a6d7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4a6d7d",
  null
  
)

export default component.exports